// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { OrderExecutionType } from "../../Utils/Trading/OrderExecutionType.js"
import { Resources } from "../properties/Resources.js"

// TODO. Inherit from DataCacheBusinessObject.
export let AllowedReport = function (key, id, rawParams)
{
    this.key = key
    this.id = id
    this.params = AllowedReport.parseRawParams(rawParams)
}

AllowedReport.REPORT_KEY_PREFIX = '_REPORTKEY_'
AllowedReport.TECHNICAL_REPORT_KEY_PREFIX = '_TECHNICALREPORTKEY_'
AllowedReport.REPORT_OrderBook = "Order Book Report"
AllowedReport.REPORT_TRADES = "Trades Report"
AllowedReport.REPORT_STATEMENT = "Statement report"
AllowedReport.REPORT_MAMACCOUNTSUMMARY = "MAM account summary"
AllowedReport.TOTAL_ROW_LABEL = "Totals:";

Object.defineProperty(AllowedReport.prototype, 'keyForServer',
{
    get: function ()
    {
        let key = this.key
        if (!key) return ''

        return key.replace(
          key.indexOf(AllowedReport.REPORT_KEY_PREFIX) !== -1
            ? AllowedReport.REPORT_KEY_PREFIX
            : AllowedReport.TECHNICAL_REPORT_KEY_PREFIX,
          '')
    }
})

AllowedReport.prototype.toString = function ()
{
    let realKey = this.key.replace(AllowedReport.REPORT_KEY_PREFIX, '')
    let reportKey = 'reports.' + realKey
    return Resources.getResource(
      Resources.hasResource(reportKey)
        ? reportKey
        : realKey)
}

AllowedReport.parseRawParams = function (rawParams)
{
    let newParams = []

    for (let i = 0, len = rawParams.length; i < len; i++)
    {
        let rawParam = rawParams[i]
        let allowedParam = new AllowedReport.Param(rawParam.name, rawParam.type)

        let rawOptionsStr = rawParam.params
        if (rawOptionsStr)
        {
            let splits = rawOptionsStr.split(',')
            for (let j = 0, j_len = splits.length; j < j_len; j++)
            {
                let split = splits[j]
                if (!split) continue

                let optionParts = split.split(':')
                let val = optionParts[0]
                let name = optionParts[1]

                allowedParam.addValue(name, parseInt(val))
            }
        }

        newParams.push(allowedParam)
    }

    return newParams
}

AllowedReport.Param = function (name, type)
{
    this.name = name
    this.type = type
    this.options = []
}

AllowedReport.Param.prototype.addValue = function (text, value)
{
    let locText = Resources.getResource('reports.' + text)
    this.options.push({ text: locText, value: value })
}

AllowedReport.Param.prototype.toString = function ()
{
    let key = 'reports.' + this.name
    return Resources.IsResourcePresent(key) ? Resources.getResource(key) : this.name
}

AllowedReport.AccessType =
{
    User: 1,
    Technical: 2,
    Both: 3
}

AllowedReport.ParamType =
{
    TextBox: 1,
    DateBox: 2,
    AccountLookup: 3,
    UsersLookup: 4,
    InstrumentsLookup: 5,
    CheckBox: 6,
    Period: 7,
    CheckBoxGroup: 8,
    AssetComboBox: 25,
    AccountLookupOnlyOneSelect: 26,
    AssetComboBoxWithoutAll: 29
}


AllowedReport.EventFromString = function (strEventType)
{
    let realEvent = strEventType;
    if (AllowedReport.OrderBookEventsLocalized[strEventType])
        realEvent = AllowedReport.OrderBookEventsLocalized[strEventType];

    switch (realEvent)
    {
        case AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10:
            return OrderExecutionType.NEW;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20:
            return OrderExecutionType.REPLACED;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42:
            return OrderExecutionType.RESTATED;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43:
            return OrderExecutionType.ACTIVATED;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11:
            return OrderExecutionType.ACCEPTED;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30:
            return OrderExecutionType.PART_FILLED;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31:
            return OrderExecutionType.FILLED;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40:
            return OrderExecutionType.CANCELED;

        case AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41:
            return OrderExecutionType.REFUSED;

        default:
            return null;
    }
}
AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10 = "Created";
AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20 = "Modified";
AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42 = "Restated";
AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43 = "Activated";
AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11 = "Accepted";
AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30 = "Partially filled";
AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31 = "Filled";
AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40 = "Cancelled";
AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41 = "Rejected";

AllowedReport.Localize = function ()
{
    AllowedReport.OrderBookEventsLocalized = {};
    //��� ����� ��� ��������� ����� ��-�� ���� ��� ������ �������������� � ��� � �������
    //���� �� ���� �� ������, ����� �����������
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40;
    AllowedReport.OrderBookEventsLocalized[Resources.getResource("reports." + AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41;
}

Resources.AddStaticLocalization(AllowedReport.Localize)